<template>
  <div>
    <el-dialog
      :title="$t('common.selectPrinter')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-select
        :value="selectedPrinterClientID"
        :placeholder="$t('common.selectPrinter')"
        @input="handleSelectPrintClient"
      >
        <el-option-group v-for="group in printerClients" :key="group.label" :label="group.label">
          <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-option-group>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleSelect">{{ $t('common.selectPrinterConfirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'SelectPrinterClientDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    onCancel: {
      type: Function,
      required: true
    },
    onSelect: {
      type: Function,
      required: true
    }
  },
  computed: {
    printerClients() {
      const workshops = this.$store.getters['printerClient/loadedItems'].filter(client => client.workshopID !== null);
      const others = this.$store.getters['printerClient/loadedItems'].filter(client => client.workshopID === null);
      const clients = {
        options: [
          {
            label: this.$t('common.plannedWorkshopPrintClient'),
            options: [
              {
                value: null,
                label: this.$t('common.plannedWorkshopPrintClient')
              }
            ]
          },
          {
            label: this.$t('common.workshopPrintClients'),
            options: workshops.map(c => ({
              value: c.id,
              label: c.name
            }))
          },
          {
            label: this.$t('common.otherPrintClients'),
            options: others.map(c => ({
              value: c.id,
              label: c.name
            }))
          }
        ]
      };
      return clients.options;
    },
    selectedPrinterClientID: {
      get: function() {
        return this.$store.getters['printerClient/getCurrentPrinterClientID'] || null;
      }
    }
  },
  created() {
    this.$store.dispatch('printerClient/getItems');
  },
  methods: {
    handleSelectPrintClient(printerClientID) {
      this.$store.dispatch('printerClient/setCurrentPrinterClientID', printerClientID);
    },
    handleSelect() {
      this.onSelect(this.selectedPrinterClientID);
    },
    handleCancel(done) {
      this.onCancel();
    }
  }
};
</script>

<style>
.el-dialog {
  width: 40%;
}
</style>
